export const API_END_POINT = {
  saveCampaignData: "/meta/saveCampaignData",
  saveAdsetData: "/meta/saveAdsetData",
  saveAdsData: "/meta/saveAdsData",
  getRecentPosts: "/post/getRecentPosts",
  getActivityLog: "/post/getLogActivity",
  postActivity: "/post/activityLog",
  savePostMedia: "/post/savePostMedia",
  getPlatformList: "/platform/getPlatform",
  findPostById: "/post/findPostById",
  createRepository: "/repository/createRepository",
  getRepository: "/repository/getRootRepositories",
  deleteRepository: "/repository/deleteRepository",
  uploadMultipleFiles: "/repository/uploadMultipleFiles",
  downloadS3Folders: "/post/downloadS3Folders",
  downloadFolder: "/repository/download-folder",
  editRepository: "/repository/editRepository",
  searchRepository: "/repository/getRootRepositories",
  copyRepository: "/repository/copyRepository",
  uploadCreative: "/creative/uploadCreative",
  getPendingCreatives: "/creative/pendingCreative",
  getZonalUserList: "/user/getZonalUserList",
  getApprovedCreatives: "/creative/approvedCreative",
  approveCreative: "/creative/approveCreative",
  getRejectedCreatives: "/creative/rejectedCreative",
  getCreatives: "/creative/getCreativeList",
  reassignCreative: "/creative/reassignCreative",
  moveRepository: "/repository/moveRepository",
  updateCreativeStatus: (id) => `/creative/${id}/status`,
  getImageTags: "/meta/getImageTags",
  registerUser: "/user/registerUser",
  getCommanDealersList:
    "/https://api.glocal360-qa.com/api/v1/common/dealers?client=bajaj",
  getSwitchApplicationApi: (domain, domainPrefix) =>
    `https://api.${domain}/api/v1/common/user?domain=${domainPrefix}.${domain}`,
  getNotificationList: "/creative/getNotificationList",
  convertPSDImage: "/meta/convertPSDImage",
  editPost: "/post/editPost",
  deletePost: "/post/deletePost",
  changeNotificationStatus: "/creative/changeNotificationStatus",
  makeNotificationCountReset: "/creative/makeNotificationCountReset",
  
};
